import { faArrowRight, faTimes, faUserGraduate } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton } from 'components';
import { HeadingItem } from 'components/heading-item/heading-item';
import { Popup, TextBox } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import React, { FC, Fragment, useState } from 'react';
import { useLoadManagerService, useSettingService, useTripService } from 'services';
import { IconOptions } from 'types';
import './training-pop-up.scss';

type Props = {
    isVisible: boolean,
    onClickRetrieve: () => void,
    onClickClose: () => void
}

let rightHandIconDetails: IconOptions = { icon: faUserGraduate, size: 'lg', color: '#0066A4' }

export const TrainingPopup: FC<Props> = ({ isVisible, onClickRetrieve, onClickClose }) => {

    const [trainerIdValue, setTrainerIdValue] = useState<string>('')
    let { loadDemoLoad } = useLoadManagerService()
    const { clearTrips } = useTripService()
    const { setTrainingMode, setTrainerId } = useSettingService()

    const handleRetrieveClicked = () => {
        if (trainerIdValue == null || trainerIdValue.trim().length === 0) {
            notify(`Please enter your trainer's ID`, 'info', 5000)
        }
        else {
            clearTrips()
            setTrainerId(trainerIdValue)
            onClickRetrieve()
            setTrainingMode(true)
        }
    }

    const handleDemoLoad = async () => {
        onClickClose()
        setTrainerId(undefined)
        setTrainingMode(true)
    }

    return (
        <Fragment>
            <Popup
                visible={isVisible}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={false}
                width={330}
                height={300}
            >
                <div>
                    <HeadingItem text={'Training Details'} rightHandIcon={rightHandIconDetails}></HeadingItem>
                    <div className={'training-popup-head'}>
                        Welcome to training mode!
                    </div>
                    <div className={'training-popup-sub-head'}>
                        What is your trainer's ID?
                    </div>
                    <div className={'training-popup-field'}>
                        <TextBox value={trainerIdValue} onValueChanged={e => setTrainerIdValue(e.value)} placeholder={`Trainer's ID`} />
                    </div>
                    <div className={'bottom-fix-action-row'}>
                        <ActionButton
                            icon={faTimes}
                            buttonColor={'#EB5757'}
                            onClick={onClickClose}
                            buttonText={'Close'}
                            iconSize={'1x'}
                            buttonWidth={'100px'}
                        />
                        <ActionButton
                            icon={faArrowRight}
                            buttonColor={'#F2994A'}
                            onClick={handleDemoLoad}
                            buttonText={'Demo Load'}
                            buttonWidth={'100px'}
                        />
                        <ActionButton
                            icon={faArrowRight}
                            buttonColor={'#76AB21'}
                            onClick={handleRetrieveClicked}
                            buttonText={'Retrieve'}
                            buttonWidth={'100px'}
                        />
                    </div>
                </div>
            </Popup>
        </Fragment>
    )
}
